import Block from "components/layout/block";
import { parse } from "lib/locale";
import { ListEntity } from "models/list-entity";
import { FunctionComponent } from "react";
import { useLocale } from "stores/hooks/locale";
import MultiSummaryTable from "./multi-table";

interface MultiSummaryProps {
  listUuid: string;
  listEntity: ListEntity;
}

const MultiSummary: FunctionComponent<MultiSummaryProps> = ({
  listUuid,
  listEntity,
}) => {
  const locale = useLocale();
  return (
    <Block title={parse(listEntity.name, locale)}>
      <MultiSummaryTable listUuid={listUuid} listEntity={listEntity} />
    </Block>
  );
};

export default MultiSummary;
